// extracted by mini-css-extract-plugin
export default {"authCard":"Login_authCard__ZKbYm","authLogo":"Login_authLogo__z74iT","authClose":"Login_authClose__EsbNb"};